import {
  Box,
  CheckBox,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

import type DefaultShiftForm from 'modules/shift_management/lib/forms/DefaultShiftForm'
import type DefaultShiftWithParamsForm from 'modules/shift_management/lib/forms/DefaultShiftWithParamsForm'
import type ShiftForm from 'modules/shift_management/lib/forms/ShiftForm'
import ShiftsEditForm from 'modules/shift_management/lib/forms/ShiftsEditForm'
import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

const renderOvertimeTooltipContent = () => {
  const newFirstOvertimeTooltipInfo = i18n.t(
    'shift_management.add_shift.new_first_overtime_tooltip'
  )
  const newSecondOvertimeTooltipInfo = i18n.t(
    'shift_management.add_shift.new_second_overtime_tooltip'
  )

  return (
    <Box textAlign="left">
      <Box paddingBottom="s8">
        <Text.Normal size="200">{newFirstOvertimeTooltipInfo}</Text.Normal>
      </Box>
      <Text.Normal size="200">{newSecondOvertimeTooltipInfo}</Text.Normal>
    </Box>
  )
}

export interface Props {
  form:
    | DefaultShiftWithParamsForm
    | ShiftForm
    | UnassignedShiftForm
    | ShiftsEditForm
    | DefaultShiftForm
  newVersion?: boolean
  isComplementaryHoursEnabled: boolean
}

const ShiftOvertimeCheckbox = ({
  form,
  isComplementaryHoursEnabled,
  newVersion = false,
}: Props) => {
  const checkboxInfo = i18n.t('shift_management.add_shift.overtime')

  const isEditForm = form instanceof ShiftsEditForm
  const indeterminate = isEditForm && form.values.extraHours === ''

  const oldTooltipInfo = indeterminate
    ? i18n.t('shift_management.edit_shifts.extra_hours_info')
    : i18n.t('shift_management.add_shift.overtime_tooltip')

  const onChange = () => {
    if (indeterminate) {
      form.setValues({
        extraHours: false,
      })
    } else if (isEditForm) {
      form.setValues({
        extraHours: !form.values.extraHours,
      })
    } else {
      form.setValues({
        extra_hours: !form.values.extra_hours,
      })
    }
  }

  const checked = isEditForm ? form.values.extraHours : form.values.extra_hours

  const [openTooltip, setOpenTooltip] = useToggle(false)

  return (
    <Box
      flexDirection="row"
      gap={newVersion ? 's4' : 's8'}
      alignItems="center"
      paddingLeft={newVersion ? 's40' : undefined}
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        <CheckBox indeterminate={indeterminate} checked={checked} onClick={() => onChange()} />
        <Text.Normal size="200" weight="medium">
          {checkboxInfo}
        </Text.Normal>
      </Box>
      {newVersion ? (
        <Tooltip.Alt
          attachment="bottom center"
          toggle={setOpenTooltip}
          open={openTooltip}
          label={isComplementaryHoursEnabled ? renderOvertimeTooltipContent() : oldTooltipInfo}
        >
          <Icon.Medium icon="info-circle-line" color="grey800" />
        </Tooltip.Alt>
      ) : (
        <Box>
          <InformationTooltip
            information={
              isComplementaryHoursEnabled ? renderOvertimeTooltipContent() : oldTooltipInfo
            }
            icon="question"
          />
        </Box>
      )}
    </Box>
  )
}

export default observer(ShiftOvertimeCheckbox)
